import { atom } from "recoil";

const searchTextAtom = atom({
	key: "listPriceAtom",
	default: [],
});

export default searchTextAtom;
